/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerDto } from '../../models/partner-dto';

export interface PartnerAdminControllerFindAllV1$Params {
}

export function partnerAdminControllerFindAllV1(http: HttpClient, rootUrl: string, params?: PartnerAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartnerDto>>> {
  const rb = new RequestBuilder(rootUrl, partnerAdminControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PartnerDto>>;
    })
  );
}

partnerAdminControllerFindAllV1.PATH = '/api/v1/partners/admin';
